module.exports = __webpack_public_path__ + "static/media/netlify-login-button.a7eb180d.svg";